import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import LifeOnLifeMovement from "./sections/LifeOnLifeMovement";
import OurSacredMission from "./sections/OurSacredMission";
import AlliloopBuildsBridgesAcrossTheCareEconomy from "./sections/AlliloopBuildsBridgesAcrossTheCareEconomy";
import WordsOfComfort from "./sections/WordsOfComfort";
import ScheduleATour from "./sections/ScheduleATour";
import RecentCommunityNews from "./sections/RecentCommunityNews";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <LifeOnLifeMovement />
      <OurSacredMission />
      <AlliloopBuildsBridgesAcrossTheCareEconomy />
      <WordsOfComfort />
      <ScheduleATour />
      <RecentCommunityNews />
      <FooterInformation />
    </div>;
}